import { render, staticRenderFns } from "./GoodsCollection.vue?vue&type=template&id=6a846520"
import script from "./GoodsCollection.vue?vue&type=script&lang=js"
export * from "./GoodsCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports